import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

export default class PhaseInfo extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Phase Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="name"
              name="name"
              label="Name"
              fullWidth
              autoComplete="pname"
              value={this.props.phase.name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.name}
              helperText={this.props.errores.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="phase_status" style={{marginRight:'10px'}}>Status</InputLabel>
              <Select
                required
                id="phaseStatus"
                name="phase_status"
                value={this.props.phase.phase_status}
                onChange={this.props.handleChange}
                disabled={this.props.reviewActive}
                error={this.props.errores.phase_status}
                helperText={this.props.errores.phase_status}
              >
                <MenuItem native="true" key={1} value={1} selected>
                  Active
                </MenuItem>
                <MenuItem native="true" key={2} value={2}>
                  Inactive
                </MenuItem>
              </Select>
            </div>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/phase/PhaseInfo.js